// 檔案類型對照
const mimeTypeObj = {
  "gif": "image/gif",
  "jpg": "image/jpeg",
  "jpeg": "image/jpeg",
  "png": "image/png",
  "pdf": "application/pdf"
}

export default mimeTypeObj